// extracted by mini-css-extract-plugin
module.exports = {"close":"RadioList_close__2FNZd","submit":"RadioList_submit__3o_ET"};